import { render } from "./CookiesLoading.vue?vue&type=template&id=c87b6f30&scoped=true"
import script from "./CookiesLoading.vue?vue&type=script&lang=js"
export * from "./CookiesLoading.vue?vue&type=script&lang=js"

import "./CookiesLoading.vue?vue&type=style&index=0&id=c87b6f30&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87b6f30"]])

export default __exports__